interface ThoughtMessageState {
  role: 'user' | 'assistant'
  isFinalized?: boolean
  generationStatus?: string
  isDevMode?: boolean
}

export function canCollapseAssistantThoughts({ role, isFinalized = true, generationStatus, isDevMode = false }: ThoughtMessageState): boolean {
  return role === 'assistant' && isFinalized && !isDevMode &&
    generationStatus !== 'PENDING' && generationStatus !== 'IN_PROGRESS' &&
    generationStatus !== 'FAILED' && generationStatus !== 'CANCELLED'
}

export function isInterimAssistantText<T extends { type: string }>(part: T): part is T & { type: 'text'; assistantTextRole: 'interim' } {
  return part.type === 'text' && 'assistantTextRole' in part && part.assistantTextRole === 'interim'
}
